/**
 * Shallow compare two objects.
 *
 * Source: https://github.com/pmndrs/zustand/blob/main/src/vanilla/shallow.ts
 */
export const isEqualShallow = <T>(objA: T, objB: T) => {
  if (Object.is(objA, objB)) return true;

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return objA === objB;
  }

  if (objA instanceof Map && objB instanceof Map) {
    if (objA.size !== objB.size) return false;

    for (const [key, value] of objA) {
      if (!Object.is(value, objB.get(key))) return false;
    }

    return true;
  }

  if (objA instanceof Set && objB instanceof Set) {
    if (objA.size !== objB.size) return false;

    for (const value of objA) {
      if (!objB.has(value)) return false;
    }
    return true;
  }

  const keysA = Object.keys(objA);

  if (keysA.length !== Object.keys(objB).length) return false;

  for (const keyA of keysA) {
    if (
      !Object.prototype.hasOwnProperty.call(objB, keyA as string) ||
      !Object.is(objA[keyA as keyof T], objB[keyA as keyof T])
    ) {
      return false;
    }
  }

  if (objA.constructor !== objB.constructor) return false;

  return true;
};
